import React from 'react';
import { List, ListItem, makeStyles, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { CustomTheme } from 'common/ui/interfaces';
import messages from '../../messages';

const useStyles = makeStyles((theme: CustomTheme) => ({
  caption: {
    paddingTop: '24px',
    paddingBottom: '16px',
  },
  link: {
    color: theme.palette.error.main,
    textDecoration: 'underline',
    fontSize: '1rem',
    lineHeight: '32px',
  },
  dateText: {
    fontSize: '1rem',
    paddingBottom: '16px',
  },
  descriptionText: {
    fontSize: '1rem',
  },
  list: {
    listStyleType: 'disc',
    padding: '0 0 0 16px',
  },
  listItem: {
    display: 'list-item',
    '&::marker': {
      content: '"• "',
    },
  },
  text: {
    fontSize: '1rem',
    lineHeight: '32px',
  },
}));

const PrivacyPolicy = () => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Typography className={classes.dateText}>
        {intl.formatMessage(messages.documentCurrentrevision)}
      </Typography>
      <Typography className={classes.descriptionText}>
        {intl.formatMessage(messages.peakPaymentsPrivacyPolicyoutlines)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.informationWeCollect)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.personalInformation)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.referralProgramWeOfferAnOptional)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.profileImage)}
          </Typography>
        </ListItem>
      </List>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.howWeUseYourInformation)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.generalUse)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.referralProgramIfYouDecideToParticipate)}
          </Typography>
        </ListItem>
      </List>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.yourChoices)}
      </Typography>
      <List className={classes.list}>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.participationInReferralProgram)}
          </Typography>
        </ListItem>
        <ListItem className={classes.listItem}>
          <Typography className={classes.text}>
            {intl.formatMessage(messages.updatingYourInformation)}
          </Typography>
          <Link className={classes.link} to="https://www.peakserve.com" target="_blank">
            www.peakserve.com
          </Link>
          .
        </ListItem>
      </List>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.dataSecurity)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.weTakeDataSecuritySeriously)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.updatesToThisPrivacyPolicy)}
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.weMayUpdateThisPrivacyPolicy)}
      </Typography>
      <Typography className={classes.caption} variant="h3">
        {intl.formatMessage(messages.contactUs)}
      </Typography>
      <Typography component="span">
        <Typography className={classes.text}>
          {intl.formatMessage(messages.ifYouHaveAnyQuestions)}
          &nbsp;
          <Link className={classes.link} to="https://www.peakserve.com" target="_blank">
            www.peakserve.com
          </Link>
          .
        </Typography>
      </Typography>
      <Typography className={classes.text}>
        {intl.formatMessage(messages.byUsingOurServices)}
      </Typography>
    </>
  );
};

export default PrivacyPolicy;
